var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_4824)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.7283 7.47406C14.3474 7.47351 13.9823 7.31998 13.7131 7.04718C13.4438 6.77437 13.2924 6.40455 13.2921 6.01883V4H6.87504C6.62885 3.99991 6.38503 4.04894 6.15755 4.14429C5.93006 4.23964 5.72335 4.37945 5.54923 4.55572C5.37511 4.732 5.23699 4.94128 5.14275 5.17164C5.04851 5.40198 5.00001 5.64887 5.00001 5.89821V17.3383C4.99919 17.5881 5.04708 17.8357 5.14095 18.0668C5.23481 18.2979 5.37282 18.5079 5.54702 18.6849C5.72122 18.8618 5.92821 19.0023 6.1561 19.098C6.38399 19.1937 6.62832 19.2429 6.87504 19.2429H14.5785C15.0756 19.2429 15.5524 19.0429 15.9039 18.6869C16.2554 18.3309 16.4529 17.8481 16.4529 17.3446V7.47406H14.7283Z",
    fill: "#37474F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.8612 16.0728H9.15194C8.53415 16.0728 8.03333 16.5799 8.03333 17.2056V19.8353C8.03333 20.461 8.53415 20.9682 9.15194 20.9682H17.8612C18.479 20.9682 18.9798 20.461 18.9798 19.8353V17.2056C18.9798 16.5799 18.479 16.0728 17.8612 16.0728Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5561 19.0903V19.6032H10.0316V19.0903H10.5561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3264 18.8584V19.6026H10.8201V17.4814H11.6406C11.8892 17.4814 12.0787 17.5435 12.2089 17.6691C12.2749 17.7345 12.3264 17.8133 12.3601 17.9004C12.3938 17.9874 12.409 18.0807 12.4046 18.1741C12.4065 18.2974 12.3765 18.419 12.3176 18.5268C12.2567 18.6322 12.1663 18.7169 12.0578 18.7702C11.9273 18.8325 11.7841 18.8627 11.6399 18.8584H11.3264ZM11.8892 18.1741C11.8892 17.9888 11.7875 17.8948 11.5841 17.892H11.3264V18.4436H11.5841C11.7875 18.4464 11.8892 18.3568 11.8892 18.1748V18.1741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5137 19.6035H14.0074L13.1604 18.3014V19.6035H12.6533V17.4824H13.1604L14.0074 18.7966V17.4824H14.5137V19.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4947 17.6591C16.6635 17.7875 16.7773 17.9766 16.8123 18.1874H16.276C16.2409 18.1117 16.1842 18.0485 16.113 18.0061C16.0091 17.9487 15.8897 17.9269 15.7726 17.9442C15.6554 17.9615 15.5471 18.0169 15.4638 18.1021C15.3619 18.2256 15.3102 18.3837 15.319 18.5444C15.319 18.7468 15.3698 18.9013 15.4715 19.0092C15.5286 19.0655 15.5967 19.109 15.6715 19.137C15.7462 19.165 15.8259 19.1767 15.9054 19.1715C16.019 19.1738 16.1303 19.1387 16.2223 19.0713C16.3164 19 16.3843 18.899 16.4153 18.7842H15.7752V18.4153H16.8388V18.9225C16.7979 19.0486 16.7336 19.1657 16.6493 19.2674C16.5579 19.3769 16.444 19.465 16.3157 19.5256C16.1707 19.5938 16.0123 19.6276 15.8525 19.6243C15.6582 19.6295 15.4659 19.5825 15.2953 19.4882C15.1393 19.3994 15.0123 19.2665 14.9296 19.1059C14.8447 18.9313 14.8005 18.7393 14.8005 18.5447C14.8005 18.3501 14.8447 18.1582 14.9296 17.9836C15.012 17.8232 15.1385 17.6903 15.2939 17.6013C15.4619 17.5072 15.6515 17.46 15.8434 17.4644C16.0759 17.454 16.3051 17.5226 16.4947 17.6591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5022 7.51264H14.7776C14.3968 7.51208 14.0317 7.35856 13.7625 7.08575C13.4932 6.81294 13.3418 6.44313 13.3414 6.05741V4.03857L16.5022 7.51264Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66642 10H9V10.6659H9.66642V10Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 10.666H9.66699V11.332H10.3334V10.666Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 10H10.3334V10.6659H10.9998V10Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6662 10.666H10.9998V11.332H11.6662V10.666Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 10H11.6667V10.6659H12.3332V10Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.666H12.3336V11.332H13V10.666Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66642 11.3311H9V11.997H9.66642V11.3311Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 11.9966H9.66699V12.6625H10.3334V11.9966Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 11.3311H10.3334V11.997H10.9998V11.3311Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6662 11.9966H10.9998V12.6625H11.6662V11.9966Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 11.3311H11.6667V11.997H12.3332V11.3311Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.9966H12.3336V12.6625H13V11.9966Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66642 12.6685H9V13.3344H9.66642V12.6685Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 13.334H9.66699V13.9999H10.3334V13.334Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 12.6685H10.3334V13.3344H10.9998V12.6685Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6662 13.334H10.9998V13.9999H11.6662V13.334Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 12.6685H11.6667V13.3344H12.3332V12.6685Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.334H12.3336V13.9999H13V13.334Z",
    fill: "#B0BEC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_4824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.c5a2b58599bd55a1c570dab9c65da005.svg";
export { ForwardRef as ReactComponent };